import { ExternalLink } from 'lucide-react'
import type Opportunity from '@/types/serializers/Opportunity.ts'
import { Card, CardContent, CardHeader } from "@/components/ui/card.tsx";

interface DeepDiveTabProps {
    opportunity: Opportunity
}

export default function DeepDiveTab({opportunity}: DeepDiveTabProps) {
    // Use deep_dives from opportunity or fallback to empty array
    const deepDiveData = opportunity.deep_dives || []

    // If no deep dive data, show placeholder
    if (deepDiveData.length === 0) {
        return (
            <div className="text-center py-12">
                <p className="text-slate-500 dark:text-slate-400">No deep dive data available for this opportunity.</p>
            </div>
        )
    }

    return (
        <div className="space-y-6">
            {deepDiveData.map((deepDiveItem, index) => (
                <Card key={index}>
                    <CardHeader>
                        <h3 className="text-lg font-semibold text-slate-900 dark:text-neutral-50 mb-4 capitalize">
                            {deepDiveItem.title}
                        </h3>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div>
                            <h4 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">Key
                                point</h4>
                            <p className="text-slate-600 dark:text-neutral-300 leading-relaxed">
                                {deepDiveItem.description}
                            </p>
                        </div>

                        <div>
                            <h4 className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-3">Prime
                                sources</h4>
                            <div className="space-y-2">
                                {deepDiveItem.sources && Array.isArray(deepDiveItem.sources) && deepDiveItem.sources.map((source: any, sourceIndex: number) => (
                                    <a
                                        key={sourceIndex}
                                        href={source.url?.startsWith('http') ? source.url : `https://${source.url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center space-x-2 text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
                                    >
                                        <ExternalLink className="w-4 h-4"/>
                                        <span>{source.title}</span>
                                    </a>
                                ))}
                                {(!deepDiveItem.sources || !Array.isArray(deepDiveItem.sources) || deepDiveItem.sources.length === 0) && (
                                    <p className="text-sm text-slate-500 dark:text-slate-400">No sources
                                        available</p>
                                )}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    )
}